import axios from "axios";
import ReactHtmlParser from "react-html-parser";
import { DISPLAY_MESSAGE, assayViewed } from "./assays";
import * as config from "../app.config";
import _ from "underscore";
import moment from "moment";
export const ADD_TO_CART = "ADD_TO_CART";
export const CART_COUNT = "CART_COUNT";
export const UPDATE_CART_UNIQUE_ID = "UPDATE_CART_UNIQUE_ID";
export const UPDATE_QUOTE_UNIQUE_ID = "UPDATE_QUOTE_UNIQUE_ID";
import { formatTradeMarkForCart, formatAPI } from "../util/format";
import { reset } from "redux-form";

const MAIN_API = `${config.ENDPOINTS.main}/v1`;

const ASSAY_API_ENDPOINTS = {
  order: "assay-order", //POST to cart with assay array
  evoOrder: `${config.ENDPOINTS.evoCart}/en/US/adirect/biorad`, //POST to EVO cart
};

axios.default.withCredentials = true;

const getGuid = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4();
};

function handleErrors(resp) {
  return (dispatch) => {
    const status = (resp && resp.status) || 503;
    switch (status) {
      case 503:
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "error",
          text: "Service currently not available.",
          key: getGuid(),
        });
        break;
      default:
    }
  };
}

function setUserId(user) {
  const output =
    user &&
    user.digitalAssaysUser &&
    user.digitalAssaysUser &&
    user.digitalAssaysUser.split("-").join("");
  return output;
}

function setHeaders(userId) {
  const headers = {
    "Content-Type": "application/json",
    userId: userId,
  };
  return headers;
}

const encodePayload = (payload) => {
  let frmBody = [];
  Object.keys(payload).forEach((item) => {
    let encodedKey = encodeURIComponent(item);
    let encodedValue = encodeURIComponent(payload[item]);
    frmBody.push(encodedKey + "=" + encodedValue);
  });
  frmBody = frmBody.join("&");
  return frmBody;
};

const processCartPayload = (orderInfo, selectedSku, isQuote) => {
  const output = {};

  const skuObject = _.findWhere(orderInfo.skuMap, { sku: selectedSku });
  output["size"] = parseInt(skuObject.size);
  output["orderType"] = isQuote ? "Quote" : "Cart";
  output["assayId"] = orderInfo.uniqueAssayId;

  return output;
};

export function processAddAssayToCart(
  orderInfo,
  selectedSku,
  isQuote,
  uniqueRowId
) {
  return (dispatch, getState) => {

    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const orderPayload = processCartPayload(orderInfo, selectedSku, isQuote);

    const ADD_TO_CART = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.order);
    return axios
      .post(ADD_TO_CART, orderPayload, {
        headers: headerConfig,
      })
      .then((resp) => {
        const {
          data: {
            data: { id },
          },
        } = resp;
        if (resp && id) {
          if (orderPayload.orderType === "Quote") {
            dispatch({
              type: ADD_TO_CART,
              payload: orderPayload,
            });
            dispatch({ type: UPDATE_QUOTE_UNIQUE_ID, payload: uniqueRowId });
          } else {
            dispatch({
              type: ADD_TO_CART,
              payload: orderPayload,
            });
            dispatch({ type: UPDATE_CART_UNIQUE_ID, payload: uniqueRowId });
          }
        }
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "success",
          text: "Assay successfully added to your cart.",
          key: getGuid(),
        });
        if (uniqueRowId) {
          dispatch(assayViewed(uniqueRowId));
        }

        dispatch(processAddAssayToEvoCart(orderInfo, selectedSku, id, isQuote));
      })
      .catch((err) => {
        dispatch(handleErrors(err));
      });
  };
}

export function processAddAssayToEvoCart(orderInfo, sku, order_uuid, isQuote) {
  return (dispatch) => {
    var orderPayload = orderInfo;
    var essentialKeys = [
      "cmd",
      "quantity",
      "customAssay",
      "sku",
      "uniqueAssayId",
      "assayTypeCode",
      "assayName",
      "reverseSeq",
      "forwardSeq",
      "probeSeq",
      "oligoItem",
      "CartQuote",
      "order_uuid",
      "flurophoreCode",
      "primerProbeCode",
      "amplifiedAssayTypecode",
    ];
    orderPayload.sku = sku;
    orderPayload.uniqueAssayId = orderInfo.uniqueAssayId;
    orderPayload.CartQuote = isQuote ? "QT" : "cart";
    orderPayload.cmd = "ajaxAddToCart";
    orderPayload.order_uuid = order_uuid;
    orderPayload.assayName = formatTradeMarkForCart(orderInfo.assayName).replace("{{Name}}", orderInfo.uniqueAssayId);
    orderPayload.probeSeq = `#ProbeId-${order_uuid}`;
    orderPayload.reverseSeq = `#RevID-${order_uuid}`;
    orderPayload.forwardSeq = `#FwdID-${order_uuid}`;
    orderPayload.flurophoreCode = orderInfo.flurophoreCode || 1606;
    orderPayload.primerProbeCode = orderInfo.primerProbeCode || 608;
    orderPayload.amplifiedAssayTypecode = orderInfo.amplifiedAssayTypecode || 0;
    orderPayload.customAssay = orderInfo.customAssay || "Y";
    const filteredPayload = _.pick(orderPayload, essentialKeys);

    var frmBody = encodePayload(filteredPayload);

    return axios
      .post(ASSAY_API_ENDPOINTS.evoOrder, frmBody)
      .then(() => {
        dispatch(reset("frmModalAddToCart"));
        dispatch(fetchCartCount());
      })
      .catch((err) => {
        dispatch(reset("frmModalAddToCart"));
        dispatch(handleErrors(err));
      });
  };
}

export function fetchCartCount() {
  return (dispatch) => {
    if (config.ISLOCALHOST) {
      const cartHtml =
        '<div class="sterling_cart"><p><a href="https://lsds-int-dev2.br.aws-livesite.io/en-us/shopping-cart" title="" target="_self"><img src="https://lsds-int-dev2.br.aws-livesite.io/evportal/framework/skins/evolution/images/icon-cart.png" width="23" height="17" border="0" alt=""/><span id="sterling_cart_count">0</span> items</a></p></div>';

      dispatch({ type: CART_COUNT, payload: ReactHtmlParser(cartHtml) });
    } else {
      //const headerConfig = setHeaders();
      const ts = moment().unix();
      axios
        .get(
          `${ASSAY_API_ENDPOINTS.evoOrder}?ts=1&tstamp=${ts}&cmd=BRHeaderCartModule&isPortalReq=Y`,
          { withCredentials: true }
        )
        .then((resp) => {
          dispatch({ type: CART_COUNT, payload: ReactHtmlParser(resp.data) });
        })
        .catch((err) => {
          dispatch(handleErrors(err));
        });
    }
  };
}
